import { LocalLandingLocations } from '@/types';

/**
 * Hardcoded geoIds for the 7 locations as the demand
 * Supported locations: Zurich, Bern, Basel, Aarau, Luzern, St. Gallen, Zug
 */

export const geoIdsForZurich: string[] = [
  'geo-canton-zuerich',
  'geo-municipality-zuerich',
  'geo-ziparea-8001-zurich',
  'geo-ziparea-8002-zurich',
  'geo-ziparea-8003-zurich',
  'geo-ziparea-8004-zurich',
  'geo-ziparea-8005-zurich',
  'geo-ziparea-8006-zurich',
  'geo-ziparea-8008-zurich',
  'geo-ziparea-8032-zurich',
  'geo-ziparea-8037-zurich',
  'geo-ziparea-8038-zurich',
  'geo-ziparea-8041-zurich',
  'geo-ziparea-8044-zurich',
  'geo-ziparea-8045-zurich',
  'geo-ziparea-8046-zurich',
  'geo-ziparea-8047-zurich',
  'geo-ziparea-8048-zurich',
  'geo-ziparea-8049-zurich',
  'geo-ziparea-8050-zurich',
  'geo-ziparea-8051-zurich',
  'geo-ziparea-8052-zurich',
  'geo-ziparea-8053-zurich',
  'geo-ziparea-8055-zurich',
  'geo-ziparea-8057-zurich',
  'geo-ziparea-8064-zurich',
];

export const geoIdsForBern: string[] = [
  'geo-canton-bern',
  'geo-municipality-bern',
  'geo-ziparea-3004-bern',
  'geo-ziparea-3005-bern',
  'geo-ziparea-3006-bern',
  'geo-ziparea-3007-bern',
  'geo-ziparea-3008-bern',
  'geo-ziparea-3010-bern',
  'geo-ziparea-3011-bern',
  'geo-ziparea-3012-bern',
  'geo-ziparea-3013-bern',
  'geo-ziparea-3014-bern',
  'geo-ziparea-3015-bern',
  'geo-ziparea-3018-bern',
  'geo-ziparea-3019-bern',
  'geo-ziparea-3020-bern',
  'geo-ziparea-3027-bern',
];

export const geoIdsForBasel: string[] = [
  'geo-canton-basel-stadt',
  'geo-municipality-basel',
  'geo-ziparea-4001-basel',
  'geo-ziparea-4031-basel',
  'geo-ziparea-4051-basel',
  'geo-ziparea-4052-basel',
  'geo-ziparea-4053-basel',
  'geo-ziparea-4054-basel',
  'geo-ziparea-4055-basel',
  'geo-ziparea-4056-basel',
  'geo-ziparea-4057-basel',
  'geo-ziparea-4058-basel',
  'geo-ziparea-4059-basel',
];

export const geoIdsForAarau: string[] = [
  'geo-canton-aargau',
  'geo-municipality-aarau',
  'geo-ziparea-5000-aarau',
  'geo-ziparea-5004-aarau',
  'geo-ziparea-5032-aarau-rohr',
];

export const geoIdsForLuzern: string[] = [
  'geo-canton-luzern',
  'geo-municipality-luzern',
  'geo-ziparea-6003-luzern',
  'geo-ziparea-6004-luzern',
  'geo-ziparea-6005-luzern',
  'geo-ziparea-6006-luzern',
  'geo-ziparea-6014-luzern',
  'geo-ziparea-6015-luzern',
];

export const geoIdsForStGallen: string[] = [
  'geo-canton-st-gallen',
  'geo-municipality-st-gallen',
  'geo-ziparea-9000-st-gallen',
  'geo-ziparea-9008-st-gallen',
  'geo-ziparea-9010-st-gallen',
  'geo-ziparea-9011-st-gallen',
  'geo-ziparea-9012-st-gallen',
  'geo-ziparea-9014-st-gallen',
  'geo-ziparea-9015-st-gallen',
  'geo-ziparea-9016-st-gallen',
];

export const geoIdsForZug: string[] = [
  'geo-canton-zug',
  'geo-municipality-zug',
  'geo-ziparea-6300-zug',
  'geo-ziparea-6300-zugerberg',
  'geo-ziparea-6317-oberwil-b-zug',
];

export const locationDropdownGeoIds: { [key in LocalLandingLocations]: string[] } = {
  [LocalLandingLocations.Zurich]: geoIdsForZurich,
  [LocalLandingLocations.Bern]: geoIdsForBern,
  [LocalLandingLocations.Basel]: geoIdsForBasel,
  [LocalLandingLocations.Aarau]: geoIdsForAarau,
  [LocalLandingLocations.Luzern]: geoIdsForLuzern,
  [LocalLandingLocations.StGallen]: geoIdsForStGallen,
  [LocalLandingLocations.Zug]: geoIdsForZug,
};
